import { motion } from 'framer-motion';

const contactMethods = [
  {
    icon: 'ri-phone-line',
    title: 'Phone',
    value: '(415) 888-5336',
    link: 'tel:+14158885336',
    linkLabel: 'Call Now',
    description: 'Mon-Fri 8AM-6PM PST',
  },
  {
    icon: 'ri-mail-line',
    title: 'Email',
    value: 'lonetrsllc@gmail.com',
    link: 'mailto:lonetrsllc@gmail.com',
    linkLabel: 'Send Email',
    description: '24/7 Response',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Location',
    value: 'Las Vegas Valley, NV',
    link: null,
    linkLabel: null,
    description: 'Henderson to Mesquite',
  },
];

export default function ContactInfo() {
  return (
    <section className="py-24 bg-dark-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(#00D4FF 1px, transparent 1px), linear-gradient(90deg, #00D4FF 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-orbitron text-5xl font-bold text-white mb-4">
            GET IN <span className="text-electric-blue">TOUCH</span>
          </h2>
          <p className="font-inter text-white/60 text-lg">
            We&apos;re here to help with all your transportation needs
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contactMethods.map((method, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-electric-blue/50 transition-all duration-300 hover:shadow-lg hover:shadow-electric-blue/20 h-full">
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-electric-blue/20 to-electric-cyan/20 border border-electric-blue/30 flex items-center justify-center">
                    <i className={`${method.icon} text-3xl text-electric-blue w-8 h-8 flex items-center justify-center`}></i>
                  </div>
                  <div className="w-full">
                    <div className="font-orbitron text-xs text-electric-blue tracking-widest mb-2">
                      {method.title}
                    </div>
                    <div className="font-inter text-white text-base font-semibold mb-2">
                      {method.value}
                    </div>
                    <div className="font-inter text-white/60 text-sm">
                      {method.description}
                    </div>
                    {method.link && (
                      <a
                        href={method.link}
                        className="inline-block mt-3 font-inter text-electric-blue text-xs hover:underline cursor-pointer"
                      >
                        {method.linkLabel}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mt-16"
        >
          <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-3xl p-4 overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3218.3!2d-115.1398!3d36.1699!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDEwJzExLjYiTiAxMTXCsDA4JzIzLjMiVw!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '1rem' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="LONE TRS Service Area Map"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
